import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import type { ResultTag } from 'src/lib/tagModalHelper';
import { useMovieTagEditStore } from 'src/composables/useMovieTagEdit';


export default /*@__PURE__*/_defineComponent({
  __name: 'MovieTagEditModal',
  setup(__props) {

const ctx = useMovieTagEditStore();

const handleClose = async(resultTags: ResultTag[]) => {
  await ctx.updateMovieTagsOfMovieList(resultTags);
  // updateMovieTagsOfMovieList が内部で editMovieTagModal.show = false をセットする
};

return (_ctx: any,_cache: any) => {
  const _component_TagModal = _resolveComponent("TagModal")!

  return (_unref(ctx).editMovieTagModal.show)
    ? (_openBlock(), _createBlock(_component_TagModal, {
        key: 0,
        title: "動画タグの編集",
        modelValue: _unref(ctx).editMovieTagModal.tags,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(ctx).editMovieTagModal.tags) = $event)),
        "is-chouki-hozon-tag-disabled": true,
        onClose: handleClose,
        onDismiss: _cache[1] || (_cache[1] = ($event: any) => (_unref(ctx).editMovieTagModal.show = false))
      }, null, 8, ["modelValue"]))
    : _createCommentVNode("", true)
}
}

})